import { render, staticRenderFns } from "./Factories.vue?vue&type=template&id=269e1e76&scoped=true&"
import script from "./Factories.vue?vue&type=script&lang=ts&"
export * from "./Factories.vue?vue&type=script&lang=ts&"
import style0 from "./Factories.vue?vue&type=style&index=0&id=269e1e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269e1e76",
  null
  
)

export default component.exports